import ChatMessage from "./ChatMessage";
import ChatParticipant from "./ChatParticipant";
import ChatConversationContext from "./ChatConversationContext";

export default class ChatConversation {
    constructor(json) {
        this.id = json['id'];
        this.userId = json['user-id'];
        this.name = json['name'];
        this.sendbirdUrl = json['sendbird-url'];
        this.sendbirdChannelType = json['sendbird-channel-type'];
        this.customType = json['custom-type'];
        this.dateCreated = json['date-created'];
        this.dateUpdated = json['date-updated'];
        this.status = json['status']
        this.messages = [];
        json['messages'].forEach(message => {
            this.messages.push(new ChatMessage(message))
        })
        this.participants = [];
        json['participants'].forEach(participant => {
            this.participants.push(new ChatParticipant(participant))
        })
        this.context = [];
        json['context'].forEach(context => {
            this.context.push(new ChatConversationContext(context))
        })
    }
}
